import classNames from "classnames";
import Table from "components/DesignSystem/Table/V2/Table";
import { useEffect, useRef } from "react";
import { Row, flexRender } from "react-table-8.10.7";
import { TaskDeadlineOverviewItem } from "types/Models/task";
import { MobileTaskRowCard } from "./MobileTaskRowCard";

type TaskTableRowProps = {
  row: Row<TaskDeadlineOverviewItem>;
  highlightUuid: string | null;
  onRowClick: (taskId: string | null) => void;
  isMobile?: boolean;
};

export const TaskTableRow = ({
  row,
  highlightUuid,
  onRowClick,
  isMobile = false,
}: TaskTableRowProps) => {
  const rowRef = useRef<HTMLTableRowElement | null>(null);
  const isHighlighted = Boolean(
    highlightUuid &&
      (row.original.task_uuid === highlightUuid ||
        row.original.alarm_uuid === highlightUuid)
  );
  const handleRowClick = () => onRowClick(row.original.task_uuid);

  useEffect(() => {
    if (isHighlighted && rowRef.current) {
      rowRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [isHighlighted]);

  return (
    <Table.Row
      ref={rowRef}
      onRowClick={handleRowClick}
      className={classNames("sm:t-border-dashed", {
        "t-cursor-pointer": row.original.task_uuid,
        "!t-cursor-auto hover:!t-bg-surface": !row.original.task_uuid,
        "t-animate-highlightTaskRow": isHighlighted,
      })}
    >
      {isMobile ? (
        <Table.Cell colSpan={row.getVisibleCells().length}>
          <MobileTaskRowCard row={row} />
        </Table.Cell>
      ) : (
        row
          .getVisibleCells()
          .map((cell) => (
            <Table.Cell key={cell.id}>
              {flexRender(cell.column.columnDef.cell, cell.getContext())}
            </Table.Cell>
          ))
      )}
    </Table.Row>
  );
};
